import { memo } from 'react'

interface ITagIconProps {
  className?: string
}

const TagIcon: React.FC<ITagIconProps> = memo(({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7184 23.3091C14.2578 23.7697 13.6871 24 13.0063 24C12.3254 24 11.7547 23.7697 11.2941 23.3091L0.720901 12.7359C0.500626 12.5156 0.325407 12.2553 0.195244 11.9549C0.0650814 11.6546 0 11.3342 0 10.9937V2.403C0 1.74218 0.235294 1.17647 0.705882 0.705882C1.17647 0.235294 1.74218 0 2.403 0H10.9937C11.3342 0 11.6546 0.0650814 11.9549 0.195244C12.2553 0.325407 12.5156 0.500626 12.7359 0.720901L23.3091 11.3242C23.7697 11.7847 24 12.3504 24 13.0213C24 13.6921 23.7697 14.2578 23.3091 14.7184L14.7184 23.3091ZM5.25 7.59998C6.49264 7.59998 7.5 6.59262 7.5 5.34998C7.5 4.10734 6.49264 3.09998 5.25 3.09998C4.00736 3.09998 3 4.10734 3 5.34998C3 6.59262 4.00736 7.59998 5.25 7.59998Z"
      fill="white"
    />
  </svg>
))

export { TagIcon }
